<template>
  <div>
    <div class="instructions">奖励发放次数说明<van-icon class="icon-instruction" name="question-o" @click="showInstructionTip = true" /></div>
    <div class="container">
      <div class="item">
        <div class="row">
          <div class="left">
            <spot :title="'加时卡'"></spot>
            <van-icon class="icon1" name="question-o" @click="showTip = true" />
          </div>
          <div class="remaining">本月剩余{{ cardRemaining }}张</div>
        </div>
        <div class="card">
          <div class="text-instruction">每月合计可发放{{ cardTotalNumber }}张，每月2日更新</div>
          <div class="cardSty">
            <div
              v-for="(card, index) in cardList"
              :class="[{ activeImg: acimg == card?.id }, 'imgSty']"
              :key="index"
              @click="checkCard(card)"
            >
              <img :src="card?.ext?.pic" />
            </div>
          </div>
          <div class="warn">选择发放的数量</div>
          <div>
            <van-stepper v-model="cardNumber" min="1" :max=cardRemaining disable-input />
          </div>
          <div class="bottom-button">
            <div :class="['verify-button', {'unactive':cardRemaining===0}]" @click="cardDialog">确认发放</div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="row">
          <div class="left">
            <spot :title="'召唤石'"></spot>
          </div>
          <div class="remaining">本月剩余{{ rockRemaining }}次</div>
        </div>
        <div class="card">
          <div class="text-instruction">每月合计可发放{{ rockTotalNumber }}次（每次100）每月2日更新</div>
          <div class="cardSty">
            <div
              :class="['activeImg', 'imgSty']"
              @click="checkCard(card)"
            >
              <img class="hei-wid-96" src="@/assets/images/squirrelCup/2024/cupTwo/rock100.png" />
            </div>
          </div>
          <div class="warn">选择发放的数量</div>
          <div>
            <van-stepper v-model="rockNumber" min="1" :max=rockRemaining disable-input />
          </div>
          <div class="bottom-button">
            <div :class="['verify-button', {'unactive':rockRemaining===0}]" @click="rockDialog">确认发放</div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="row">
          <div class="left">
            <spot :title="'宠物口粮'"></spot>
          </div>
          <div class="remaining">本月剩余{{ grainRemaining }}次</div>
        </div>
        <div class="card">
          <div class="text-instruction">每月合计可发放{{ grainTotalNumber }}次（每次360g）每月2日更新</div>
          <div class="cardSty">
            <div
              :class="['activeImg', 'imgSty']"
              @click="checkCard(card)"
            >
              <img class="hei-wid-96" src="@/assets/images/squirrelCup/2024/cupTwo/grain360.png" />
            </div>
          </div>
          <div class="warn">选择发放的数量</div>
          <div>
            <van-stepper v-model="grainNumber" min="1" :max=grainRemaining disable-input />
          </div>
          <div class="bottom-button">
            <div :class="['verify-button', {'unactive':grainRemaining===0}]" @click="grainDialog">确认发放</div>
          </div>
        </div>
      </div>
      <!-- <div class="history">
        <div style="text-decoration: underline" @click="showTip = true">
          什么是加时卡？
        </div>
        <div @click="toHistory">加时卡记录></div>
      </div>
      <div class="warn">选择奖励黄金加时卡的时长</div>
      <div class="cardSty">
        <div
          v-for="(card, index) in cardList"
          :class="[{ activeImg: acimg == card?.id }, 'imgSty']"
          :key="index"
          @click="checkCard(card)"
        >
          <img :src="card?.ext?.pic" />
        </div>
      </div>
      <div class="warn">选择发货的数量</div>
      <div>
        <van-stepper v-model="value" min="1" max="10" disable-input />
      </div>
      <div class="bottom-button">
        <div class="btnSty" @click="show = true">确认发放</div>
      </div> -->
      <van-dialog
        v-model="showCardDialog"
        title="奖励黄金加时卡"
        @confirm="sendCard"
        show-cancel-button
        confirmButtonColor="#58ABF6"
        confirmButtonText="确定"
      >
        <div class="contet">
          <div>你将给{{ userInfo.name }}同学发放</div>
          <div class="colSty">
            {{ cardNumber }}张{{ cardObj.ext?.minutes }}分钟{{
              cardObj.ext?.type == 1 ? "普通加时卡" : "黄金加时卡"
            }}
          </div>
          <div>是否确认？</div>
        </div>
      </van-dialog>
      <van-dialog
        v-model="showRockDialog"
        title="奖励召唤石"
        @confirm="sendReward(1)"
        show-cancel-button
        confirmButtonColor="#58ABF6"
        confirmButtonText="确定"
      >
        <div class="contet">
          <div>你将给{{ userInfo.name }}同学发放</div>
          <div class="colSty">
            召唤石×{{ rockNumber*100 }}
          </div>
          <div>是否确认？</div>
        </div>
      </van-dialog>
      <van-dialog
        v-model="showGrainDialog"
        title="奖励宠物口粮"
        @confirm="sendReward(2)"
        show-cancel-button
        confirmButtonColor="#58ABF6"
        confirmButtonText="确定"
      >
        <div class="contet">
          <div>你将给{{ userInfo.name }}同学发放</div>
          <div class="colSty">
            宠物口粮×{{ grainNumber*360 }}g
          </div>
          <div>是否确认？</div>
        </div>
      </van-dialog>
      <van-dialog
        v-model="showFailDialog"
        @confirm="closeFailDialog"
        title="奖励失败"
        confirmButtonColor="#58ABF6"
        confirmButtonText="知道了"
      >
        <div class="contet">
          <div class="margin-tb-48">{{ tipsMsg }}</div>
        </div>
      </van-dialog>
      <van-dialog
        v-model="showTip"
        title="什么是加时卡？"
        :show-confirm-button="false"
        show-cancel-button
        cancelButtonColor="#58ABF6"
        cancelButtonText="关闭"
      >
        <div class="tipText">
          <div>可以增加孩子娱乐时长的加时卡</div>
          <div>分为普通加时卡和黄金加时卡，区别如下</div>
        </div>
        <div>
          <div class="tabSty">
            <div class="tHrad">
              <div class="thSty" v-for="(th, index) in thList" :key="index">
                {{ th }}
              </div>
            </div>
            <div class="tbCol">
              <div class="tBody" v-for="(td, index) in tdList" :key="index">
                <div class="tdSty">{{ td.lebal }}</div>
                <div class="tdSty">{{ td.huangjin }}</div>
                <div class="tdSty">{{ td.putong }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-dialog>
      <van-dialog
        v-model="showInstructionTip"
        title="奖励发放次数"
        :show-confirm-button="false"
        show-cancel-button
        cancelButtonColor="#58ABF6"
        cancelButtonText="我知道了"
      >
        <div class="tipText1">
          <div>根据您每月经销商的等级，发放加时卡，召唤石和宠物口粮的可用奖励次数</div>
          <div>说明：召唤石100/次，宠物口粮360g/次</div>
        </div>
        <div>
          <div class="tabSty border-none">
            <img
              src="@/assets/images/squirrelCup/2024/cupTwo/rewardInstruction.png"
              alt=""
              style="width: 100%;"
            />
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { RadioGroup, Radio, Stepper, Toast } from "vant";
import { timecardlist, rewardentertainmenttimecard, getPropList } from "@/api/squirrelCup";
import spot from "./components/spot.vue";

export default {
  data() {
    return {
      showCardDialog: false,
      showRockDialog: false,
      showGrainDialog: false,
      showFailDialog: false,
      showTip: false,
      showInstructionTip: false,
      cardNumber: 1,
      rockNumber: 1,
      grainNumber: 1,
      cardTotalNumber: null,
      rockTotalNumber: null,
      grainTotalNumber: null,
      cardRemaining: null,
      rockRemaining: null,
      grainRemaining: null,
      tipsMsg: '',
      acimg: "",
      cardObj: {},
      userInfo: {},
      cardList: [],
      thList: ["类型", "黄金加时卡", "普通加时卡"],
      tdList: [
        {
          lebal: "有效期",
          huangjin: "3天",
          putong: "7天",
        },
        {
          lebal: "使用限制",
          huangjin: "无",
          putong: "每天限用5张",
        },
        {
          lebal: "孩子如何获得",
          huangjin: "督学师奖励",
          putong: "周打基础星级达标系统奖励",
        },
        {
          lebal: "时长",
          huangjin: "5/10/20分钟",
          putong: "5分钟",
        },
      ],
    };
  },
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Stepper.name]: Stepper,
    spot,
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("headInfo"));
    this.getCard();
    this.getPropList();
    document.title ="奖励发放"
  },
  methods: {
    getCard() {
      console.log(1221);
      let param = {};
      timecardlist({ param }).then((res) => {
        console.log(res);
        this.cardList = res.data;
        this.cardObj = this.cardList[0];
        this.acimg = this.cardList[0].id;
      });
    },
    getPropList() {
      const userInfo = JSON.parse(localStorage.getItem("userInfoId"));
      const params = {
        param: {
          campusId: Number(userInfo.campusId),
        },
      }
      getPropList({...params}).then((res) => {
        if(res.code == 0){
          res.data.forEach(item => {
            if(item.propType == 3){
              this.cardTotalNumber = item.propNum
              this.cardRemaining = item.remainPropNum;
            }else if(item.propType == 1){
              this.rockTotalNumber = item.propNum;
              this.rockRemaining = item.remainPropNum;
            }else if(item.propType == 2){
              this.grainTotalNumber = item.propNum;
              this.grainRemaining = item.remainPropNum;
            }
          });
        }else{
          Toast(res.message);
        }
      }).catch(err => {
        Toast(err);
      })
    },
    checkCard(info) {
      this.acimg = info.id;
      this.cardObj = info;
    },
    sendCard() {
      let agentId = JSON.parse(localStorage.getItem("userInfoId")).agentUserId;
      let acountId = JSON.parse(localStorage.getItem("headInfo")).accountId;
      let campusId = JSON.parse(localStorage.getItem("userInfoId")).campusId;
      let name = this.cardObj.ext.type == 1 ? "普通加时卡" : "黄金加时卡";
      let param = {
        account_id: Number(acountId), // 账号ID
        agentUserId: Number(agentId),
        campusId: Number(campusId),
        number: this.cardNumber, // 加时卡数量
        propType: 3, // 奖励类型1.召唤石2.宠物口粮3.卡片
        addTimeCardType: this.cardObj.ext?.minutes == 5?31:this.cardObj.ext?.minutes == 10?32:33,// 加时卡时长

        item_id: this.cardObj.id,
        config_name: this.cardObj.ext?.minutes + "分钟" + name,
      };
      rewardentertainmenttimecard({ param }).then((res) => {
        if (res.code == 0) {
          Toast('奖励发放成功');
          setTimeout(() => {
            location.reload();
          }, 2000);
        }else if(res.code == 1){
          this.tipsMsg = res.message;
          this.showFailDialog = true;
        }else {
          Toast(res.message);
        }
      });
    },
    sendReward(type) {
      let agentId = JSON.parse(localStorage.getItem("userInfoId")).agentUserId;
      let acountId = JSON.parse(localStorage.getItem("headInfo")).accountId;
      let campusId = JSON.parse(localStorage.getItem("userInfoId")).campusId;
      let param = {
        account_id: Number(acountId),
        agentUserId: Number(agentId),
        campusId: Number(campusId),
        number: type==1 ? this.rockNumber : this.grainNumber, 
        propType: type,

        item_id: this.cardObj.id,
        config_name: type==1 ? "100召唤石" : "360g宠物口粮",
      };
      rewardentertainmenttimecard({ param }).then((res) => {
        if(res.code == 0){
          Toast('奖励发放成功');
          setTimeout(() => {
            location.reload();
          }, 2000);
        }else if(res.code == 1){
          this.tipsMsg = res.message;
          this.showFailDialog = true;
        }else {
          Toast(res.message);
        }
      })
    },
    closeFailDialog() {
      this.showFailDialog = false;
      location.reload();
    },
    toHistory() {
      this.$router.push({
        path: "/winterGame/records",
      });
    },
    cardDialog() {
      if(this.cardRemaining == 0){
        return
      }else{
        this.showCardDialog = true
      }
    },
    rockDialog() {
      if(this.rockRemaining == 0){
        return
      }else{
        this.showRockDialog = true
      }
    },
    grainDialog() {
      if(this.grainRemaining == 0){
        return
      }else{
        this.showGrainDialog = true
      }
    },
    success() {
      Toast("奖励发放成功");
    }
  },
};
</script>
<style scoped lang="less">
.border-none {
  border: none !important;
}
.margin-tb-48 {
  margin: 48px 0;
}
.instructions {
  height: 72px;
  padding-left: 48px;
  background: linear-gradient( 136deg, #F2F9FF 0%, #DDEFFF 100%);
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #58ABF6;
  line-height: 40px;
  // text-align: right;
  font-style: normal;
  display: flex;
  align-items: center;
  .icon-instruction {
    font-size: 32px;
    margin-left: 6px;
  }
}
.container {
  // margin: 32px 48px 0 48px;
  background: #F6F9FD;
  .item {
    width: 100%;
    padding: 24px 16px;
    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 32px;
      box-sizing: border-box;
      .left {
        display: flex;
        align-items: center;
        .icon1 {
          font-size: 32px;
          margin-left: 10px;
        }
      }
      .remaining {
        font-size: 28px;
        color: #58ABF6;
        line-height: 40px;
      }
    }
    .card {
      background: #FFFFFF;
      border-radius: 16px;
      margin-top: 16px;
      padding: 32px;
      .text-instruction {
        font-weight: 400;
        font-size: 28px;
        color: #323232;
        line-height: 40px;
      }
      .warn {
        font-size: 32px;
        color: #323232;
        margin-top: 28px;
        margin-bottom: 40px;
      }
      .bottom-button {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 48px;
        .verify-button {
          width: 312px;
          height: 64px;
          background: #58ABF6;
          border-radius: 32px;
          border: 2px solid #58ABF6;
          font-size: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #FFFFFF;
          font-weight: 500;
        }
        .unactive {
          background: #ccc;
          border: 2px solid #ccc;
        }
      }
    }
  }
  .history {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    color: #58abf6;
  }
  .cardSty {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    margin-top: 24px;
    padding: 12px;
    box-sizing: border-box;
    .imgSty {
      width: 176px;
      height: 120px;
      background: #ffffff;
      border-radius: 8px;
      border: 2px solid #dcdcdd;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-right: 45px;
      margin-bottom: 20px;
    }
    img {
      width: 144px;
      height: 104px;
    }
    .hei-wid-96 {
      height: 96px;
      width: 96px;
    }
    .activeImg {
      border: 2px solid #58abf6;
    }
  }
  .btnSty {
    position: absolute;
    bottom: 66px;
    left: 50%;
    transform: translateX(-50%);
    width: 600px;
    height: 96px;
    text-align: center;
    line-height: 96px;
    background: #58abf6;
    font-size: 36px;
    color: #ffffff;
    font-weight: bold;
    border-radius: 57px;
  }
  .contet {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 24px;
    padding-bottom: 20px;
    .colSty {
      font-size: 32px;
      color: #58abf6;
      font-weight: bold;
      margin-top: 10px;
      margin-bottom: 16px;
    }
  }
  .tipText {
    font-size: 28px;
    color: #323232;
    margin: 32px 48px;
  }
  .tipText1 {
    font-size: 28px;
    color: #999999;
    line-height: 40px;
    margin: 32px 48px;
  }
  .tabSty {
    background: #ffffff;
    border: 2px solid #e6e6e6;
    width: 544px;
    // height: 520px;
    margin: 0 auto;
    margin-bottom: 48px;

    .tHrad {
      display: flex;
      justify-content: space-between;
      background: #e4f1fd;
    }
    .thSty,
    .tdSty {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 37%;
      height: 108px;
      text-align: center;
      font-size: 28px;
      color: #323232;
      border-left: 2px solid #e6e6e6;
      padding: 0 14px;
    }

    .tHrad :first-child,
    .tBody :first-child {
      width: 26%;
      border-left: none;
    }
    .tBody {
      display: flex;
      justify-content: space-between;
    }
    .tBody:nth-of-type(even) {
      background: #f6f9fd;
    }
  }
  /deep/ .van-dialog__header {
    font-weight: 600;
    font-size: 40px;
    color: #323232;
  }
  /deep/ .van-stepper {
    width: 256px;
    height: 64px;
    border-radius: 8px;
    border: 2px solid #dcdcdd;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /deep/ .van-stepper__input {
    flex: 1;
    background: #ffffff;
    border-left: 2px solid #dcdcdd;
    border-right: 2px solid #dcdcdd;
    margin: 0;
  }
}
</style>
